import React from "react";
import Modal from "../Modal/Modal";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const customCancelButtonStyles = () => ({
  root: {
    backgroundColor: "#efefef",
    color: "#000",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#d4d4d4",
      boxShadow: "none"
    }
  }
});

const customSubmitButtonStyles = () => ({
  root: {
    backgroundColor: "var(--color-main)",
    color: "#fff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#000",
      boxShadow: "none"
    }
  }
});

const CustomSubmitButton = withStyles(customSubmitButtonStyles)(Button);
const CustomCancelButton = withStyles(customCancelButtonStyles)(Button);

const SendingFormDataInfoModal = props => {
  const { modalToggled, toggleModal, handleSendingData, handleFillOutForm } = props;

  const handleCancel = () => {
    toggleModal();
  };

  const handleSubmit = () => {
    handleFillOutForm();
  };

  return (
    <div>
      <Modal modalToggled={modalToggled} toggleModal={toggleModal} hasClosingButton={true}>
        {/* TODO: Make dynamic  */}
        <h1>Digitale Voranmeldung</h1>
        <p>
          Mit dieser Funktion kannst Du digital deinen Besuch im Notdienst in der
          Kleintierpraxis/-klinik ankündigen und alle relevanten Daten vorab übermitteln.
        </p>
        <p>
          Hierfür musst Du erst die Notfall Ersteinschätzung durchgeführt haben und dann erneut auf
          „Digitale Voranmeldung“ klicken
        </p>
        <p style={{fontStyle:'italic'}}>
          (Hinweis: Die digitale Voranmeldung wird z.Z. noch nicht von allen
          Kleintierpraxen/-kliniken unterstützt. Alternativ melde Dich bitte vorab telefonisch an.)
        </p>

        <div className="sendingFormDataModal__Buttons">
          <CustomCancelButton
            className="sendingFormDataModal__Buttons--cancel"
            size="small"
            variant="contained"
            onClick={handleCancel}
            type="submit"
          >
            Abbrechen
          </CustomCancelButton>
          <CustomSubmitButton
            className="sendingFormDataModal__Buttons--continue"
            size="small"
            variant="contained"
            color="primary"
            type="submit"
            onClick={handleSubmit}
          >
            Notfall Ersteinschätzung
          </CustomSubmitButton>
        </div>
      </Modal>
    </div>
  );
};

export default SendingFormDataInfoModal;
